import { render, staticRenderFns } from "./sportappointcal.vue?vue&type=template&id=a145d954&scoped=true"
import script from "./sportappointcal.vue?vue&type=script&lang=js"
export * from "./sportappointcal.vue?vue&type=script&lang=js"
import style0 from "./sportappointcal.vue?vue&type=style&index=0&id=a145d954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a145d954",
  null
  
)

export default component.exports